<button
  mat-icon-button
  class="notifications"
  [matBadgeHidden]="!notifications.length"
  [matBadge]="notificationCount() || null"
  (click)="toggleWindow()"
>
  <mat-icon>notifications_none</mat-icon>
</button>
